<template>
  <div class="vehicle-picker">
    <el-input
      :value="value"
      :disabled="disabled"
      :placeholder="placeholder"
      clearable
      @input="onManualInput"
      @clear="onManualInput('')"
    >
      <el-popover
        slot="append"
        v-model="popoverVisible"
        placement="bottom-start"
        width="360"
        trigger="click"
        popper-class="vehicle-picker-popover"
        :disabled="disabled"
        @show="onPopoverShow"
      >
        <div class="vehicle-picker__toolbar">
          <el-input v-model="keyword" size="small" clearable prefix-icon="el-icon-search" placeholder="车牌号码" />
          <el-tooltip content="刷新" placement="top">
            <el-button size="small" icon="el-icon-refresh" :loading="loading" @click="refresh" />
          </el-tooltip>
          <el-tooltip content="车辆管理" placement="top">
            <el-button v-permission="'vehicle:list'" size="small" icon="el-icon-setting" @click="openManage" />
          </el-tooltip>
        </div>
        <div v-loading="loading" class="vehicle-picker__tree-wrap">
          <el-tree
            ref="treeRef"
            :data="displayTree"
            node-key="id"
            highlight-current
            default-expand-all
            :expand-on-click-node="false"
            :props="{ children: 'children', label: 'label', disabled: 'disabled' }"
            :render-content="renderTreeContent"
            @node-click="selectNode"
          />
          <div v-if="!loading && !displayTree.length" class="vehicle-picker__empty">暂无车辆数据</div>
        </div>
        <el-button slot="reference" icon="el-icon-arrow-down" :disabled="disabled" title="选择车辆" />
      </el-popover>
    </el-input>
  </div>
</template>

<script>
import { buildVehicleTree, filterVehicleTree, findVehicleNode } from '@/utils/vehicleTree'
import { getVehicleTree, isRequestSuccess } from './lingdongApi'

export default {
  name: 'VehicleTreePicker',
  props: {
    value: { type: String, default: '' },
    vehicleId: { type: [String, Number], default: null },
    disabled: { type: Boolean, default: false },
    placeholder: { type: String, default: '请输入或选择车牌号' }
  },
  data() {
    return { loading: false, loaded: false, popoverVisible: false, keyword: '', tree: [] }
  },
  computed: {
    displayTree() { return filterVehicleTree(this.tree, this.keyword) }
  },
  watch: {
    vehicleId() { this.syncCurrentVehicle() }
  },
  methods: {
    onManualInput(value) {
      this.$emit('input', value)
      this.$emit('manual-input', value)
    },
    onPopoverShow() {
      if (!this.loaded) this.refresh()
      else this.syncCurrentVehicle()
    },
    async refresh() {
      this.loading = true
      try {
        const res = await getVehicleTree()
        if (!isRequestSuccess(res)) throw new Error(res.msg || '车辆树加载失败')
        this.tree = buildVehicleTree(res.data || [])
        this.loaded = true
        this.syncCurrentVehicle()
        this.$emit('refreshed')
      } catch (error) {
        this.tree = []
        this.$message.error(error.msg || error.message || '车辆树加载失败')
      } finally {
        this.loading = false
      }
    },
    syncCurrentVehicle() {
      this.$nextTick(() => {
        const tree = this.$refs.treeRef
        if (!tree || typeof tree.setCurrentKey !== 'function') return
        const selected = this.vehicleId == null ? null : findVehicleNode(this.tree, this.vehicleId)
        tree.setCurrentKey(selected ? selected.id : null)
      })
    },
    selectNode(row) {
      if (!row || row.nodeType !== 'VEHICLE' || row.disabled) return
      const selected = {
        vehicleId: row.vehicleId,
        vehicleNo: row.vehicleNo,
        plateColor: Number(row.plateColor)
      }
      this.$emit('input', row.vehicleNo)
      this.$emit('select', selected)
      this.popoverVisible = false
    },
    openManage() {
      this.popoverVisible = false
      this.$emit('manage')
    },
    renderTreeContent(h, { node, data }) {
      if (data.nodeType === 'VEHICLE') {
        return h('span', { class: 'vehicle-picker__node' }, [
          h('i', { class: 'el-icon-truck vehicle-picker__vehicle-icon' }),
          h('span', node.label)
        ])
      }
      const count = data.vehicleCount == null ? '' : ` [${data.vehicleCount}]`
      return h('span', { class: 'vehicle-picker__node' }, [
        h('i', { class: 'el-icon-folder vehicle-picker__group-icon' }),
        h('span', `${data.label}${count}`)
      ])
    }
  }
}
</script>

<style scoped>
.vehicle-picker { width: 100%; }
.vehicle-picker__toolbar { display: flex; gap: 6px; padding-bottom: 8px; border-bottom: 1px solid #ebeef5; }
.vehicle-picker__toolbar .el-input { flex: 1; }
.vehicle-picker__tree-wrap { height: 320px; margin-top: 8px; overflow: auto; }
.vehicle-picker__empty { padding: 56px 0; color: #909399; text-align: center; }
.vehicle-picker__node { display: inline-flex; align-items: center; gap: 5px; }
.vehicle-picker__group-icon { color: #e6a23c; }
.vehicle-picker__vehicle-icon { color: #409eff; }
</style>
